import script from "./DetailFleetGroupView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailFleetGroupView.vue?vue&type=script&setup=true&lang=js"

import "./DetailFleetGroupView.vue?vue&type=style&index=0&id=fccb90be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fccb90be"]])

export default __exports__